import { Link } from "react-router-dom";
import { ArrowRight, Building2, Map, Truck, ShieldCheck, Monitor } from "lucide-react";
import PageTransition from "../components/PageTransition";
import PageHero from "../components/PageHero";
import ImagePlaceholder from "../components/ImagePlaceholder";
import { useTranslation } from "../i18n/LanguageContext";
import { services as serviceData } from "../data/services";

const iconMap: Record<string, React.ElementType> = {
  construction: Building2, "travaux-publics": Map, logistique: Truck, sst: ShieldCheck, digital: Monitor,
};

export default function Services() {
  const t = useTranslation();

  return (
    <PageTransition>
      <PageHero title={t.services_title} description={t.services_description} />

      <section className="py-24 md:py-32">
        <div className="max-w-content mx-auto px-6 md:px-12">
          {serviceData.map((s, i) => {
            const Icon = iconMap[s.slug] || Monitor;
            return (
              <article key={s.slug} className={`grid lg:grid-cols-2 gap-16 items-center ${i > 0 ? "mt-24 pt-24 border-t border-border" : ""}`}>
                <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                  <div className="flex items-center gap-3 mb-5">
                    <Icon size={20} className="text-accent" strokeWidth={1.5} />
                    <span className="text-[12px] uppercase tracking-[0.15em] font-semibold text-accent">{s.subtitle}</span>
                  </div>
                  <h2 className="font-serif text-heading-sm md:text-[36px] mb-5">{s.title}</h2>
                  <p className="text-secondary text-[17px] leading-[1.8] mb-8">{s.description}</p>
                  <Link to={`/services/${s.slug}`} className="inline-flex items-center gap-2 text-[13px] font-semibold text-accent hover:gap-3 transition-all duration-300">
                    {t.home_learn_more} <ArrowRight size={14} />
                  </Link>
                </div>
                <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                  <ImagePlaceholder label={s.imageLabel} src={s.imageSrc} aspectRatio="3/2" />
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </PageTransition>
  );
}
